module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "campaignForm",
    staticClass: "campaign-form",
    attrs: {
      "model": _vm.campaignForm,
      "rules": _vm.rules,
      "label-width": "190px",
      "label-position": "left"
    }
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), (!_vm.isEditing) ? _c('p', [_vm._v("\n      Let's first get some details on what we want to call this new campaign, we need to know when\n      this campaign is starting and ending as well.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isEditing) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      The campaign type is very important, getting this right ensures the best reporting\n      available. This cannot be changed once the campaign is created.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isEditing) ? _c('p', {
    staticClass: "small"
  }, [_vm._v("\n      Due to interaction processing and analytics the campaign type and keyword cannot be changed.\n    ")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Title",
      "prop": "campaignTitle"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.campaignForm.campaignTitle),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignTitle", $$v)
      },
      expression: "campaignForm.campaignTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Perpetual Campaign",
      "prop": "perpetual"
    }
  }, [_c('el-switch', {
    on: {
      "change": _vm.clearCampaignDates
    },
    model: {
      value: (_vm.campaignForm.perpetual),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "perpetual", $$v)
      },
      expression: "campaignForm.perpetual"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Select to setup a permanent campaign without an end date.")])], 1), _vm._v(" "), (_vm.campaignForm.perpetual) ? _c('el-form-item', {
    attrs: {
      "label": "Start Date",
      "prop": "campaignDates"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime"
    },
    on: {
      "change": _vm.handleChangeCampaignDate
    },
    model: {
      value: (_vm.campaignForm.campaignDates[0]),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm.campaignDates, 0, $$v)
      },
      expression: "campaignForm.campaignDates[0]"
    }
  })], 1) : _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "campaignDates"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetimerange",
      "range-separator": "To"
    },
    model: {
      value: (_vm.campaignForm.campaignDates),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignDates", $$v)
      },
      expression: "campaignForm.campaignDates"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Type",
      "prop": "campaignType"
    }
  }, [_c('el-select', {
    staticClass: "full-width",
    attrs: {
      "value": null,
      "disabled": _vm.isEditing
    },
    model: {
      value: (_vm.campaignForm.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "campaignType", $$v)
      },
      expression: "campaignForm.campaignType"
    }
  }, _vm._l((_vm.campaignTypeOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Winning Disqualification Duration",
      "prop": "campaignWinningQualificationDuration"
    }
  }, [_c('el-select', {
    staticClass: "duration-selectors",
    attrs: {
      "value": null,
      "filterable": "",
      "placeholder": "days"
    },
    model: {
      value: (_vm.campaignForm.duration_days),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "duration_days", $$v)
      },
      expression: "campaignForm.duration_days"
    }
  }, _vm._l((_vm.range(0, 100)), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item + ' days',
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.pollCampaignTypes.includes(_vm.campaignForm.campaignType)) ? _c('div', [_c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('h3', [_vm._v("Poll Details")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "question"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.campaignForm.pollQuestion),
      callback: function($$v) {
        _vm.$set(_vm.campaignForm, "pollQuestion", $$v)
      },
      expression: "campaignForm.pollQuestion"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "poll-choice-container",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('h4', [_vm._v("Choices")]), _vm._v(" "), _c('p', [_vm._v("Specify poll choices along with possible matches for each choice")]), _vm._v(" "), _vm._l((_vm.campaignForm.pollChoices), function(choice, idx) {
    return _c('poll-choice-input', {
      key: idx,
      attrs: {
        "choice": choice,
        "idx": idx,
        "disabled": _vm.isEditing
      },
      on: {
        "onRemoveChoice": _vm.handleChoiceRemove
      }
    })
  })], 2), _vm._v(" "), _c('div', [(!_vm.isEditing) ? _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "icon": "fa fa-plus"
    },
    on: {
      "click": _vm.handleAddPollChoice
    }
  }, [_vm._v("Add Choice")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed"
  }), _vm._v(" "), _c('h3', [_vm._v("Channels")]), _vm._v(" "), _c('p', [_vm._v("These are the means by which interactions come into or get sent out of a campaign.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Keyword"
    }
  }, [_vm._l((_vm.campaignForm.channelKeyword), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticStyle: {
        "margin-left": "2px"
      },
      attrs: {
        "closable": !_vm.isEditing,
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), (_vm.keywordInputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "disabled": _vm.isEditing
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isEditing) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add keyword")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": "Keywords cannot be added when campaign is live",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle fa-lg"
  })]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("Press enter key after each keyword added.")])], 1) : _c('p', [_vm._v("Keywords cannot be added when campaign is live")])], 2), _vm._v(" "), (_vm.smsChannelSelected && _vm.canEncryptOriginators) ? _c('el-form-item', {
    attrs: {
      "label": "Encrypt Originator",
      "prop": "encryptOriginator"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.encryptOriginator),
      callback: function($$v) {
        _vm.encryptOriginator = $$v
      },
      expression: "encryptOriginator"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.smsChannelSelected) ? _c('el-form-item', {
    attrs: {
      "label": "Reply Message",
      "prop": "replyMessage"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.replyMessage),
      callback: function($$v) {
        _vm.replyMessage = $$v
      },
      expression: "replyMessage"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.smsCount) + " (chars left / messages)")]), _vm._v(" "), (_vm.encryptOriginator) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n        Please replace the part of the reply would like encrypted with "), _c('strong', [_vm._v("{hashid}")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("e.g. Thank you for entering, please visit https://example.com/enter?uid="), _c('strong', [_vm._v("{hashid}")])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "SMS Credentials",
      "visible": _vm.showSmsCredentialsDialog,
      "width": "30%",
      "show-close": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showSmsCredentialsDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "smsReplyCredentialsForm",
    attrs: {
      "model": _vm.smsReplyCredentialsForm,
      "rules": _vm.smsCredentialsrules
    }
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v("\n          Kindly provide us with the username and password for your sms line. These detials are\n          vital for us to pull in your interactions.\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Username",
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "Username"
    },
    model: {
      value: (_vm.smsReplyCredentialsForm.username),
      callback: function($$v) {
        _vm.$set(_vm.smsReplyCredentialsForm, "username", $$v)
      },
      expression: "smsReplyCredentialsForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password",
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "full-width",
    attrs: {
      "placeholder": "password"
    },
    model: {
      value: (_vm.smsReplyCredentialsForm.password),
      callback: function($$v) {
        _vm.$set(_vm.smsReplyCredentialsForm, "password", $$v)
      },
      expression: "smsReplyCredentialsForm.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmSmsCredential
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('channel-select', {
    attrs: {
      "createChannels": this.channelList,
      "selectedChannels": _vm.campaignForm.channels
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Create a new channel")]), _vm._v(" "), _c('p', [_vm._v("The channel you're looking for not listed above, create a new one below.")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    on: {
      "click": _vm.handleRequestTwitterAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Twitter'
    }
  }), _vm._v("Twitter\n      ")], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleRequestFacebookAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Facebook'
    }
  }), _vm._v("Facebook\n      ")], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleRequestInstagramAuth
    }
  }, [_c('social-icon', {
    staticClass: "fa fa-fw",
    attrs: {
      "type": 'Instagram'
    }
  }), _vm._v("Instagram\n      ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.handleFormSave
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v("\n          Save\n        ")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-725006fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/CampaignForm.vue
// module id = 3336
// module chunks = 3